<template>
	<div :id="id" class="split-block-list">
		<SplitBlockItem
			v-for="(item, index) in items"
			:key="item.id"
			:fields="item.fields"
			:idx="showIndex ? index + 1 : 0"
		>
		</SplitBlockItem>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const id = computed(() => props.fields?.id?.value);
const showIndex = computed(() => props.fields?.showIndex?.value);
const items = computed(() => props.fields.items || []);
</script>

<style lang="scss">
.split-block-list {
	padding: var(--spacing-2, 16px);
}
</style>
